import { Card, CardContent } from "@shadcn-in-nx/ui/card";
import { ShieldCheck, ScanSearch, BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import SecurityScoreGauge from "./SecurityScoreGauge";

const SecurityEmptyState = () => {
    const { t } = useTranslation();

    return (
        <div className="space-y-6">
            <Card className="border-dashed">
                <CardContent className="flex flex-col items-center justify-center py-12 gap-6">
                    <SecurityScoreGauge score={0} size={200} />
                    <div className="text-center max-w-md">
                        <h3 className="text-lg font-semibold mb-2">
                            {t("security.emptyTitle")}
                        </h3>
                        <p className="text-sm text-muted-foreground">
                            {t("security.emptyDescription")}
                        </p>
                    </div>
                </CardContent>
            </Card>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card className="bg-blue-50/50 border-blue-100">
                    <CardContent className="flex items-start gap-3 p-4">
                        <ScanSearch className="h-8 w-8 text-blue-500 mt-0.5 shrink-0" />
                        <div>
                            <p className="font-medium text-sm">{t("security.step1Title")}</p>
                            <p className="text-xs text-muted-foreground mt-1">{t("security.step1Desc")}</p>
                        </div>
                    </CardContent>
                </Card>
                <Card className="bg-indigo-50/50 border-indigo-100">
                    <CardContent className="flex items-start gap-3 p-4">
                        <ShieldCheck className="h-8 w-8 text-indigo-500 mt-0.5 shrink-0" />
                        <div>
                            <p className="font-medium text-sm">{t("security.step2Title")}</p>
                            <p className="text-xs text-muted-foreground mt-1">{t("security.step2Desc")}</p>
                        </div>
                    </CardContent>
                </Card>
                <Card className="bg-green-50/50 border-green-100">
                    <CardContent className="flex items-start gap-3 p-4">
                        <BarChart3 className="h-8 w-8 text-green-500 mt-0.5 shrink-0" />
                        <div>
                            <p className="font-medium text-sm">{t("security.step3Title")}</p>
                            <p className="text-xs text-muted-foreground mt-1">{t("security.step3Desc")}</p>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default SecurityEmptyState;
